export function compareBy(key, sortType) {
    if (sortType == true) {
        return function (a, b) {
            if(typeof a[key] === 'string') {
                a[key].toLowerCase()
            }
            if(typeof b[key] === 'string') {
                b[key].toLowerCase()
            }
            if (a[key] < b[key]) return -1;
            if (a[key] > b[key]) return 1;
            return 0;
        };
    }

    if (sortType == false) {
        return function (a, b) {
            if(typeof a[key] === 'string') {
                a[key].toLowerCase()
            }
            if(typeof b[key] === 'string') {
                b[key].toLowerCase()
            }
            if (a[key] > b[key]) return -1;
            if (a[key] < b[key]) return 1;
            return 0;
        };
    }
}


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/component/CompareFunc.js